const SonanAudioHandler = (function (username, playables, bucketPrefix, onPlayStart = null, onPlayEnd = null) {
    let sonanCurrentSound = null;
    let sonanTempSounds = new Map();

    let currentIndex = 0;

    let searchInput = document.getElementById('search');
    if (searchInput!==null){
        searchInput.blur();
        document.addEventListener('scroll', function(e) {
            if (searchInput.getBoundingClientRect().bottom <= 0){
                searchInput.blur();
            }
        });
    }

    document.addEventListener('keydown', function(e) {
        if (document.activeElement.tagName!=='INPUT' && (e.key === 'ArrowRight' || e.key === 'ArrowLeft' || e.key === 'p')) {
            if (e.key === 'ArrowRight') {
                currentIndex++;
                if (currentIndex >= playables.length) {
                    currentIndex = 0;
                }
            } else if (e.key === 'ArrowLeft') {
                currentIndex--;
                if (currentIndex < 0) {
                    currentIndex = playables.length - 1;
                }
            }

            playables[currentIndex].click();
        }
    });

    function _updatePlayables(plbs) {
        let tempSampleId = playables[currentIndex].getAttribute('data-sonan-playable-id');
        playables = plbs;
        _findPlayable(tempSampleId);
    }

    function _findPlayable(sampleid) {
        for (let i =0; i<playables.length; i++){
            if (playables[i].getAttribute('data-sonan-playable-id') === sampleid){
                currentIndex = i;
            }
        }
    }

    function _playSound(sampleid, ext, duration, el) {
        if (Map.hasOwnProperty(sampleid)){
            playSoundHandling(sonanTempSounds.get(sampleid), duration, el, sampleid);
        } else {
            el.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>';
            el.disabled = true;
            el.classList.add('disabled');
            el.onclick=null;

            let xhr = new XMLHttpRequest();
            xhr.responseType = 'blob';
            xhr.onload = function (e) {
                sonanTempSounds.set(sampleid, e.currentTarget.response);
                playSoundHandling(sonanTempSounds.get(sampleid), duration, el, sampleid);
            };
            xhr.onprogress = (event) => {
                el.innerHTML = '<span class="d-block text-light" style="font-size: 14px !important; font-weight: 300 !important; line-height: 0.95 !important; height: calc(33px - 0.75rem); margin-left: -6px; margin-right: -6px; margin-top: 6px">'+(event.loaded/event.total*100).toFixed(0)+'<span style="font-size: 8px; font-weight: 300 !important; margin-left: -2px">%</span></span>';
            };
            xhr.open('GET', 'https://'+bucketPrefix+'.bangerly.com/samplesLQ/'+sampleid+'.mp3', true);
            xhr.send();
        }
    }

    function createDownloadLink(sampleid, ext, blob, title, creator) {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = (title+" "+creator+"."+ext).replaceAll(' ', '_');
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }

    function _downloadSample(sampleid, ext, title, creator, el) {
        let oldInner = el.innerHTML;
        el.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>';
        el.disabled = true;
        el.classList.add('disabled');

        if (username === ''){
            window.location = "/signin";
        }
        let opts = {
            method: 'GET',
            mode: 'same-origin',
            headers: {
                'X-CSRF-TOKEN': document.getElementById("csrf-meta").getAttribute('content'),
                'Content-Type': 'application/json',
            },
            referrerPolicy: 'no-referrer',
        };

        fetch('/sample/download/'+sampleid, opts).then( function (res) {
            if (res.status === 200){
                res.text().then( sampleUrl => {
                    let xhr = new XMLHttpRequest();
                    xhr.responseType = 'blob';
                    xhr.onload = function (e) {
                        el.innerHTML = oldInner;
                        el.disabled = false;
                        el.classList.remove('disabled');

                        sonanTempSounds.set(sampleid, e.currentTarget.response);
                        let downloadDisplay = document.getElementById('downloads_' + sampleid);
                        if (downloadDisplay !== null && creator !== username) {
                            downloadDisplay.innerHTML = " "+parseInt(downloadDisplay.innerHTML) + 1;
                        }
                        createDownloadLink(sampleid, ext, e.currentTarget.response, title, creator);
                        fetch('/account/profile/credits', opts).then(function (cr) {
                            cr.json().then(function (json) {
                                if (json.credits != null) {
                                    let al = document.getElementById('creditsLeftAlert');
                                    al.classList.remove('alert-fade-out-short', 'd-none');
                                    al.offsetWidth;
                                    al.innerHTML = '<p class="mb-0">You now have ' + json.credits.credits + ' earned credits and ' + json.credits.weekly_credits + ' free weekly credits left!</p>';
                                    al.classList.add('alert-fade-out-short');
                                }
                            });
                        });
                    };
                    xhr.onprogress = (event) => {
                        el.innerHTML = '<span class="d-block text-light" style="font-size: 14px !important; font-weight: 300 !important; line-height: 0.95 !important; height: calc(33px - 0.75rem); margin-left: -6px; margin-right: -6px; margin-top: 6px">'+(event.loaded/event.total*100).toFixed(0)+'<span style="font-size: 8px; font-weight: 300 !important; margin-left: -2px">%</span></span>';
                    };
                    xhr.open('GET', sampleUrl, true);
                    xhr.send();
                });
            }
            else if (res.status === 403){
                alert("Error 403, you do not have permission to download, you're either not logged in, not verified or you are banned.")
            }
            else if (res.status === 402){
                res.json().then(function (json) {
                    alert(json.errors);
                })
            } else  {
                alert("Error "+res.status+", something went wrong.")
            }

            if (res.status!==200){
                el.innerHTML = oldInner;
                el.disabled = false;
                el.classList.remove('disabled');
            }
        });
    }

    function _toggleSampleLike(sampleid, creatorid, likeOrUnlike, el) {
        if (username === ''){
            window.location = "/signin";
        } else {
            let body = {
                sample_id: sampleid,
                creator_id: creatorid
            };

            let opts = {
                method: 'PUT',
                mode: 'same-origin',
                headers: {
                    'X-CSRF-TOKEN': document.getElementById("csrf-meta").getAttribute('content'),
                    'Content-Type': 'application/json',
                },
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(body)
            };

            fetch('/sample/'+likeOrUnlike, opts).then( function (response) {
                if (response.status === 200){
                    if (likeOrUnlike === 'like'){
                        el.innerHTML = '<span class="fas fa-heart-broken" style="opacity: 0.65"></span>';
                        el.onclick = function () {
                            _toggleSampleLike(sampleid, creatorid, 'unlike', el);
                        };
                    } else {
                        el.innerHTML = '<span class="fas fa-heart"></span>';
                        el.onclick = function () {
                            _toggleSampleLike(sampleid, creatorid, 'like', el);
                        };
                    }
                } else {
                    response.json().then(function (json) {
                        alert(json.errors);
                    });
                }
            });
        }
    }


    function playSoundHandling(blob ,duration, el, sampleid){
        let objecturl = window.URL.createObjectURL(blob);

        let interval = null;
        let progressBar = document.getElementById('smprgs_'+sampleid);

        if (sonanCurrentSound != null){
            sonanCurrentSound.pause();
            sonanCurrentSound.currentTime = 0;
        }

        sonanCurrentSound = new Audio();
        sonanCurrentSound.src = objecturl;

        const onStopOrEnd =  function () {
            el.innerHTML = '<span class="fas fa-play"></span>';
            el.onclick = function () {
                playSoundHandling(blob, duration, el, sampleid);
            };
            progressBar.style.width = '0%';
            window.clearInterval(interval);
            window.URL.revokeObjectURL(objecturl);

            if (onPlayEnd !== null){
                onPlayEnd();
            }
        };
        sonanCurrentSound.onended = function () {
            onStopOrEnd();
        };
        sonanCurrentSound.onpause = function () {
            onStopOrEnd();
        };
        sonanCurrentSound.onplay = function(){
            if (onPlayStart !== null){
                onPlayStart();
            }

            el.innerHTML = '<span class="fas fa-stop"></span>';
            el.disabled = false;
            el.classList.remove('disabled');
            el.onclick = function () {
                sonanCurrentSound.pause();
                sonanCurrentSound.currentTime = 0;
            };

            let progresIncr = 1.0/duration;
            progressBar.style.width = (parseFloat(progressBar.style.width.replace('%', ''))+progresIncr)+'%';
            interval = setInterval(function () {
                let old = parseFloat(progressBar.style.width.replace('%', ''));
                if (old<100.0){
                    progressBar.style.width = (old+progresIncr)+'%';
                }
            }, 10);
        };

        sonanCurrentSound.play();
    }

    return {
        playSound: _playSound,
        toggleSampleLike: _toggleSampleLike,
        downloadSample: _downloadSample,
        findPlayable: _findPlayable,
        updatePlayables: _updatePlayables
    }
});

module.exports = SonanAudioHandler;